<h1 class="title">
  {{ "cartItems.whishlist.title" | cxTranslate }}
</h1>
<ng-container *ngIf="wishList">
  <ng-container *ngIf="wishList?.entries?.length > 0; else emptyWishList">
    <table role="table" aria-describedby="wishlist">
      <thead>
        <tr role="row" class="cx-item-list-header cx-wish-list-header">
          <th role="columnheader" class="cx-item-list-desc">
            {{ "cartItems.product" | cxTranslate }}
          </th>
          <th role="columnheader" class="cx-item-list-price">
            {{ "cartItems.itemPrice" | cxTranslate }}
          </th>
          <th role="columnheader" class="cx-item-list-actions">
            {{ "cartItems.actions" | cxTranslate }}
          </th>
        </tr>
      </thead>
      <cx-wish-list-item [cartEntry]="wishList" [userId]="userId" (removeItem)="removeItem($event)"></cx-wish-list-item>
    </table>
  </ng-container>

  <ng-template #emptyWishList>
    <h3>{{ "cartItems.whishlist.empty" | cxTranslate }}</h3>
  </ng-template>
</ng-container>